<template>
  <div class="home">
    <Header></Header>
    <div class="router-view">
      <router-view />
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default {
  name: "Home",
  components: {
    Header,
    Footer,
  },
  watch: {
    "$store.state.Lingua"(Lingua) {
      fn_CambiaLingua(Lingua, this);
    },
  },
};

function fn_CambiaLingua(lingua, vm) {
  try {
    let labels_italiano = {};
    let labels_inglese = {};
    let labels_tedesco = {};
    let labels_francese = {};

    let labels_errori_italiano = {};
    let labels_errori_inglese = {};
    let labels_errori_tedesco = {};
    let labels_errori_francese = {};

    switch (lingua) {
      case "IT":
        vm.labels = labels_italiano;
        vm.labels_errori = labels_errori_italiano;
        break;
      case "EN":
        vm.labels = labels_inglese;
        vm.labels_errori = labels_errori_inglese;
        break;
      case "DE":
        vm.labels = labels_tedesco;
        vm.labels_errori = labels_errori_tedesco;
        break;
      case "FR":
        vm.labels = labels_francese;
        vm.labels_errori = labels_errori_francese;
        break;
      default:
        vm.labels = labels_inglese;
        vm.labels_errori = labels_errori_inglese;
        break;
    }
  } catch (error) {
    vm.registraErrore(error, "Home-fn_CambiaLingua");
  }
}
</script>

<style>
.home {
  margin-top: 15px;
  margin-bottom: 15px;
}

.router-view {
  min-height: 300px;
}
</style>
